<template>
	<common-card
		class="omapi-campaign-settings__publish"
		contentClass="omapi-card__border"
	>
		<template v-slot:title>Visibility &amp; Status</template>
		<div class="omapi-campaign-settings__minor-publishing">
			<slot/>
		</div>

		<template v-slot:footer>
			<core-save-button
				color="green"
				:disabled="!changed"
				:saving="saving"
			/>
		</template>

	</common-card>
</template>

<script lang="js">
export default  {
	props : {
		changed : Boolean,
		saving  : Boolean,
	},
}
</script>
